import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { REFERRAL_CODE } from 'src/app/core/models/cookies.model';
import { AnalyticsService } from 'src/app/core/services/analytics-service';
import { ICodeVerificationForm, IRegistrationForm } from '../../interfaces/auth.interface';
import { AuthStoreService } from './auth-store.service';
import { RegistrationStoreService } from './registration-store.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  public errorMessages = {
    INVALID_REFERRAL_CODE: 'Kod polecający utracił ważność lub jest niepoprawny.',
    USER_NAME_ALREADY_IN_USE: 'Adres e-mail jest już zajęty.',
    unknown: 'Wystąpił nieznany błąd. Spróbuj ponownie później.',
  };

  private readonly utmNames = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content', 'referrer'];

  constructor(
    private analytics: AnalyticsService,
    private authStore: AuthStoreService,
    private registrationStore: RegistrationStoreService,
    private cookie: CookieService) {
  }


  public register(
    registrationFullData: IRegistrationForm,
  ): Observable<any> {
    return this.authStore.register(registrationFullData).pipe(
    );
  }

  public addToCookiesAndGetUtmJson(): string {
    const utmObject = {};

    this.utmNames.forEach((key) => {
      const cookie = this.cookie.get(key);

      if (cookie && cookie !== '') {
        utmObject[key] = cookie;
      }
    });

    return JSON.stringify(utmObject);
  }

  public clearUtm(): void {
    this.utmNames.forEach((key) => {
      this.cookie.remove(key, {
        domain: `.${location.hostname
          .split('.')
          .reverse()
          .slice(0, 2)
          .reverse()
          .join('.')}`,
      });
    });
  }

  public getReferralCodeFromCookie(): string {
    return this.cookie.get(REFERRAL_CODE);
  }

  public addReferralCodeToCookie(referralCode: string): void {
    this.cookie.put(REFERRAL_CODE, referralCode);
  }

  public trackRegistrationEvent(name: string, referralCode: string = null): void {
    const userId = this.authStore.userInfo.sub;
    const referral = referralCode || this.getReferralCodeFromCookie();

    const event = {
      GAEventCategory: name,
      event: 'GAEvent',
      userId,
    };

    if (referral) {
      this.analytics.trackRegistrationEventWithGtmIfEnabled({ ...event, referral });
    } else {
      this.analytics.trackRegistrationEventWithGtmIfEnabled(event);
    }
  }

  public registerEmail(
    registrationForm: IRegistrationForm): Observable<any> {
    return this.registrationStore.registerEmail(registrationForm).pipe();
  }

  public goToEmailVerification(email: string, code: string, regulations: string[]): void {
    return this.registrationStore.goToEmailVerification(email, code, regulations);
  }

  public verifyEmail(code: string): Observable<any> {
    return this.registrationStore.verifyEmailCode(code);
  }

  public resendVerificationEmail(): Observable<any> {
    return this.registrationStore.resendVerificationEmail();
  }

  public addPhone(
    registrationForm: IRegistrationForm): Observable<any> {
    return this.registrationStore.addPhone(registrationForm).pipe();
  }

  public verifyPhone(
    codeVerificationForm: ICodeVerificationForm): Observable<any> {
    return this.registrationStore.verifyPhoneCode(codeVerificationForm);
  }

  public resendVerificationSms(): Observable<any> {
    return this.registrationStore.resendVerificationSms();
  }

  public addPassword(
    registrationForm: IRegistrationForm): Observable<any> {
    return this.registrationStore.addPassword(registrationForm).pipe();
  }

  public backToFirstStep() {
    return this.registrationStore.backToFirstStep();
  }

  public getCode() {
    return this.registrationStore.userInfo.code ? this.registrationStore.userInfo.code : null;
  }


}
